import { all, fork } from 'redux-saga/effects';
import calendarSagas from './calendar';
import bettingSaga from './betting';

const sagas = [
  ...calendarSagas,
  ...bettingSaga,
];

export default function* mySaga() {
  yield all(sagas.map(s => fork(s)));
}



// WEBPACK FOOTER //
// ./src/sagas/index.js